module.exports = __webpack_public_path__ + "static/getting-started-4cf67f8d4fc9779ff46069f240d3b1c0.svg";